/*
 * Taken from https://svelte.dev/repl/0ace7a508bd843b798ae599940a91783?version=3.16.7
 */

/** Dispatch event on click outside of node */

import { getRootDocument } from "$/utils/Utils";

export function clickOutside(node, { ignoreSelectors = [] } = {}) {
    let isDragging = false;
    let startX, startY;
    const threshold = 5; 

    const handleMouseDown = (event) => {
        startX = event.clientX;
        startY = event.clientY;
        isDragging = false;

        getRootDocument().addEventListener("mousemove", handleMouseMove);
    };

    const handleMouseMove = (event) => {
        const deltaX = Math.abs(event.clientX - startX);
        const deltaY = Math.abs(event.clientY - startY);
        if (deltaX > threshold || deltaY > threshold) {
            isDragging = true;
        }
    };

    const handleClick = (event) => {
        getRootDocument().removeEventListener("mousemove", handleMouseMove);

        const shouldIgnore = ignoreSelectors.some((selector) =>
            event.target.closest(selector),
        );

        if (
            !isDragging && 
            !shouldIgnore &&
            node &&
            !node.contains(event.target) &&
            !event.defaultPrevented
        ) {
            node.dispatchEvent(
                new CustomEvent("click_outside", {
                    detail: {
                        node: node,
                        target: event.target,
                    },
                }),
            );
        }
    };

    const handleMouseUp = () => {
        getRootDocument().removeEventListener("mousemove", handleMouseMove);
    };

    getRootDocument().addEventListener("mousedown", handleMouseDown, true);
    getRootDocument().addEventListener("click", handleClick, true);
    getRootDocument().addEventListener("mouseup", handleMouseUp, true);

    return {
        update(newOptions) {
            ignoreSelectors = newOptions.ignoreSelectors || [];
        },
        destroy() {
            getRootDocument().removeEventListener("mousedown", handleMouseDown, true);
            getRootDocument().removeEventListener("click", handleClick, true);
            getRootDocument().removeEventListener("mouseup", handleMouseUp, true);
            getRootDocument().removeEventListener("mousemove", handleMouseMove);
        },
    };
}
